export type NavItem = {
  labelKey: string;
  path: string;
  icon?: string;
  colorIcon?: boolean;
  activePaths?: string[];
  children?: NavItem[];
};

// Matches actual backend role/type combinations:
// agent  → roles: ["agent"],         type: "company"
// hr     → roles: ["hr"],            type: "company"
// owner  → roles: ["tenant","owner"],type: "individual"
// tenant → roles: ["tenant"],        type: "individual"
// admin  → roles: ["administrator"]
export type UserRole = 'agent' | 'hr' | 'owner' | 'tenant' | 'admin';

export const resolveSidebarRole = ({
  roles,
  type,
}: {
  roles?: string[];
  type?: 'individual' | 'company' | null;
}): UserRole => {
  const userRoles = roles?.map((r) => r.toLowerCase()) ?? [];

  if (userRoles.includes('administrator')) return 'admin';

  if (type === 'company') {
    return userRoles.includes('agent') ? 'agent' : 'hr';
  }

  if (userRoles.includes('owner')) return 'owner';
  return 'tenant';
};

const individualNavItems: NavItem[] = [
  {
    labelKey: 'nav.find_accommodation',
    path: '/',
    icon: '/icons/search.svg',
  },
  {
    labelKey: 'nav.list_of_requests',
    path: '/my-requests',
    icon: '/icons/bars.svg',
  },
  {
    labelKey: 'nav.my_properties',
    path: '/properties',
    icon: '/icons/all_available_updated.svg',
  },
  {
    labelKey: 'nav.upload_property',
    path: '/properties/new',
    icon: '/icons/home_add.svg',
  },
  { labelKey: 'nav.favorites', path: '/favorites', icon: '/icons/heart.svg' },
];

const navConfig: Record<UserRole, NavItem[]> = {
  agent: [{ labelKey: 'nav.properties', path: '/', icon: '/icons/search.svg' }],
  hr: [
    {
      labelKey: 'nav.request_offer',
      path: '/',
      icon: '/icons/home.svg',
    },
    {
      labelKey: 'nav.my_requests',
      path: '/my-requests',
      icon: '/icons/bars.svg',
    },
    { labelKey: 'nav.favorites', path: '/favorites', icon: '/icons/heart.svg' },
  ],
  owner: individualNavItems,
  tenant: individualNavItems,
  admin: [
    {
      labelKey: 'nav.dashboard',
      path: '/',
      icon: '/icons/dashboard.svg',
    },
    {
      labelKey: 'nav.all_properties',
      path: '/admin/properties',
      icon: '/icons/all_available_properties.svg',
    },
    {
      labelKey: 'nav.my_properties',
      path: '/admin/my-properties',
      icon: '/icons/all_available_updated.svg',
    },
    {
      labelKey: 'nav.new_submissions',
      path: '/admin/submissions',
      icon: '/icons/new_property_submissions.svg',
    },
    {
      labelKey: 'nav.offer_requests',
      path: '/admin/offer-requests',
      icon: '/icons/offer_requests.svg',
    },
    {
      labelKey: 'nav.user_property_requests',
      path: '/admin/user-requests',
      icon: '/icons/user_propery_requests.svg',
    },
    {
      labelKey: 'nav.management_system',
      path: '/admin/management',
      icon: '/icons/managment_system.svg',
      activePaths: [
        '/admin/management/users',
        '/admin/management/amenities',
        '/admin/management/areas',
        '/admin/management/seasons',
      ],
      children: [
        {
          labelKey: 'nav.users',
          path: '/admin/management/users',
        },
        {
          labelKey: 'nav.amenities',
          path: '/admin/management/amenities',
        },
        {
          labelKey: 'nav.areas',
          path: '/admin/management/areas',
        },
        {
          labelKey: 'nav.seasons',
          path: '/admin/management/seasons',
        },
      ],
    },
  ],
};

export default navConfig;
